import React, { useEffect, useRef } from 'react';
import { Eraser } from 'lucide-react';

// Finger / stylus signature box for tablets; returns a PNG data URL (or '' when cleared)
export const SignaturePad = ({ onChange, testid = 'signature-pad' }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    const c = ref.current;
    let w = 0;
    const fit = () => {
      if (c.offsetWidth === w) return;
      w = c.offsetWidth;
      const ratio = window.devicePixelRatio || 1;
      c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
      const ctx = c.getContext('2d');
      ctx.scale(ratio, ratio); ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#0f172a';
      if (dirty.current) { dirty.current = false; onChange(''); }
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(c);
    return () => ro.disconnect();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pt = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(...pt(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext('2d'); ctx.lineTo(...pt(e)); ctx.stroke(); dirty.current = true; };
  const up = () => { if (!drawing.current) return; drawing.current = false; if (dirty.current) onChange(ref.current.toDataURL('image/png')); };
  const clear = () => { const c = ref.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); dirty.current = false; onChange(''); };

  return (
    <div>
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-36 border-2 border-dashed border-blue-300 rounded-lg bg-white touch-none cursor-crosshair" data-testid={testid} />
      <div className="flex justify-between items-center mt-1">
        <span className="text-xs text-gray-500">Patient signs here with a finger or stylus</span>
        <button type="button" onClick={clear} className="text-xs text-gray-600 hover:text-red-600 flex items-center gap-1" data-testid={`${testid}-clear`}><Eraser className="w-3 h-3" /> Clear</button>
      </div>
    </div>
  );
};
